import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

/**
 * Global loading store used to indicate in-flight network requests and save/load actions.
 * Maintains a global pending counter and optional scoped counters.
 */
export const useLoadingStore = defineStore('loading', () => {
  const pending = ref(0);
  const scopes = ref<Record<string, number>>({});

  function start(scope?: string) {
    pending.value++;
    if (scope) {
      scopes.value[scope] = (scopes.value[scope] || 0) + 1;
    }
  }

  function stop(scope?: string) {
    if (pending.value > 0) pending.value--;
    if (scope && scopes.value[scope] > 0) {
      scopes.value[scope]--;
      if (scopes.value[scope] === 0) {
        delete scopes.value[scope];
      }
    }
  }

  const isLoading = computed(() => pending.value > 0);
  function isScopeLoading(scope: string) {
    return !!scopes.value[scope];
  }

  return { pending, scopes, start, stop, isLoading, isScopeLoading };
});
